import { useNavigate } from 'react-router-dom';
import { saveHomeReturn } from '@/utils/homeReturnStore';

export default function Solutions() {
  const navigate = useNavigate();

  const items = [
    {
      tag: 'Residential',
      title: 'Solar for the home you live in.',
      copy: 'Custom systems for single-family and multi-family homes — designed around your roof, your usage, and your bill.',
      img: 'https://readdy.ai/api/search-image?query=Documentary%20architectural%20photography%20of%20a%20real%20lived-in%20single%20family%20California%20modernist%20home%20shot%20on%20medium%20format%20film%2C%20matte%20black%20monocrystalline%20solar%20panels%20flush%20mounted%20on%20a%20low%20pitched%20standing%20seam%20metal%20roof%20with%20visible%20fine%20seams%2C%20weathered%20cedar%20cladding%20with%20authentic%20grain%20and%20knots%2C%20board%20formed%20concrete%20garden%20wall%2C%20mature%20olive%20tree%20casting%20soft%20dappled%20shadows%20on%20gravel%20driveway%2C%20low%20late%20afternoon%20sun%20raking%20across%20facade%20producing%20long%20naturalistic%20shadows%20and%20warm%20highlights%20on%20window%20frames%2C%20subtle%20atmospheric%20haze%2C%20restrained%20cinematic%20color%20grade%2C%20sharp%20lens%20micro%20contrast%2C%20no%20CGI%20feel%2C%20unposed%20candid%20architectural%20editorial%20in%20the%20spirit%20of%20Iwan%20Baan&width=1000&height=750&seq=sol-residential-01&orientation=landscape',
      link: 'Explore residential',
      path: '/residential',
    },
    {
      tag: 'Commercial',
      title: 'Solar for the places you build.',
      copy: 'Scalable installations for offices, retail, hospitality, warehousing and mixed-use — engineered for uptime and long-term ROI.',
      img: 'https://readdy.ai/api/search-image?query=modern%20low%20rise%20commercial%20office%20building%20with%20large%20cleanly%20integrated%20rooftop%20solar%20panel%20array%2C%20minimalist%20architecture%2C%20light%20facade%2C%20subtle%20landscaping%2C%20bright%20natural%20daylight%2C%20clear%20sky%2C%20editorial%20architecture%20photography%2C%20calm%20premium%20corporate%20feeling%2C%20cool%20neutral%20tones&width=1000&height=750&seq=sol-commercial-01&orientation=landscape',
      link: 'Explore commercial',
      path: '/commercial',
    },
  ];

  const handleSelect = (path: string) => {
    saveHomeReturn(window.scrollY, 'solutions');
    navigate(path);
  };

  return (
    <section id="solutions" className="py-[64px] md:py-[120px] bg-solar-bg">
      <div className="container-x">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 mb-14 md:mb-16">
          <div>
            <p className="text-xs font-medium text-solar-green tracking-wider uppercase">Solutions</p>
            <h2 className="display-font mt-4 text-[34px] md:text-[48px] font-semibold leading-[1.05] text-solar-ink">
              Two paths.<br/>One clean future.
            </h2>
          </div>
          <div className="flex md:items-end">
            <p className="text-solar-muted text-base md:text-[17px] leading-relaxed max-w-[540px]">
              Whether you're powering a single home or an entire property portfolio, Sunfield designs solar systems that fit your architecture, your energy profile, and your ambitions.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
          {items.map((it) => (
            <button
              key={it.tag}
              type="button"
              onClick={() => handleSelect(it.path)}
              className="group block cursor-pointer rounded-2xl text-left bg-transparent border-0 p-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-solar-green focus-visible:ring-offset-4 focus-visible:ring-offset-solar-bg"
            >
              <div className="aspect-[4/3] w-full overflow-hidden rounded-2xl bg-solar-divider">
                <img src={it.img} alt={it.title} loading="lazy" decoding="async" className="w-full h-full object-cover object-top group-hover:scale-[1.02] transition-transform duration-700" />
              </div>
              <div className="mt-6">
                <p className="text-xs font-medium text-solar-muted tracking-wide">{it.tag}</p>
                <h3 className="display-font mt-2 text-[24px] md:text-[30px] font-semibold text-solar-ink leading-tight">
                  {it.title}
                </h3>
                <p className="mt-3 text-solar-muted text-[15px] leading-relaxed max-w-[480px]">{it.copy}</p>
                <span className="inline-flex items-center gap-2 mt-5 text-sm font-medium text-solar-ink group-hover:text-solar-green transition-colors">
                  {it.link}
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}